export default [
  {
    path: "/trade-ideas-v2",
    name: "Trade Ideas v2",
    component: () => import("@/app/modules/trade-ideas-v2/pages/trade-ideas.component.vue"),
  },
  {
    path: "/trade-ideas-v2/authorization",
    name: "Pré-autorização Trade Ideas v2",
    component: () => import("@/app/modules/trade-ideas-v2/pages/authorization.component.vue"),
  },
  {
    path: "/trade-ideas-v2/authorization/create",
    name: "Nova autorização Trade Ideas v2",
    component: () => import("@/app/modules/trade-ideas-v2/pages/new-authorization.component.vue"),
  },
];
